(() => {
  'use strict';
  if (window.veloraReviewLinkLoaded) return;
  window.veloraReviewLinkLoaded = true;

  function reviewSummary() {
    const groups = [];
    document.querySelectorAll('#MainContent [data-velora-reviews]').forEach(root => {
      const unique = new Map();
      root.querySelectorAll('[data-velora-review]').forEach(card => {
        if (card.closest('[data-velora-reviews]') !== root) return;
        const rating = Number(card.dataset.veloraReviewRating);
        unique.set(card.dataset.veloraReview, rating > 0 && rating <= 5 ? rating : null);
      });
      if (unique.size) groups.push({ target: root.closest('.shopify-section'), ratings: [...unique.values()] });
    });
    document.querySelectorAll('#MainContent .shopify-section').forEach(section => {
      if (section.querySelector('[data-velora-reviews]')) return;
      const cards = [...section.querySelectorAll('.testimonial-card')].filter(card => !card.closest('.splide__slide--clone'));
      if (!cards.length) return;
      groups.push({ target: section, ratings: cards.map(card => {
        const stars = card.querySelector('.testimonial-card__stars');
        const rating = stars ? Number(stars.style.getPropertyValue('--rating')) : 0;
        return rating > 0 && rating <= 5 ? rating : null;
      }) });
    });
    const ratings = groups.flatMap(group => group.ratings);
    const scored = ratings.filter(rating => rating !== null);
    const target = groups.find(group => group.target && group.target.id)?.target;
    if (!ratings.length || !target) return null;
    return { target, count: ratings.length, average: scored.length ? scored.reduce((sum, rating) => sum + rating, 0) / scored.length : null };
  }

  function refresh() {
    const summary = reviewSummary();
    document.querySelectorAll('section[id^="MainProduct-"], product-info[data-velora-pdp]').forEach(section => {
      const wrapper = [...section.querySelectorAll('.product__media-wrapper')].find(element => element.offsetWidth > 0);
      if (!wrapper) return;
      let row = section.querySelector('.velora-review-link');
      if (!summary) { row?.remove(); return; }
      const title = section.querySelector('h1');
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      let header = title?.closest('.velora-product-header, .product__title, .velora-review-link-title-row');
      if (mobile && title && !header) {
        header = document.createElement('div');
        header.className = 'velora-review-link-title-row';
        title.before(header);
        header.append(title);
      }
      section.querySelectorAll('.velora-review-link-header').forEach(element => element.classList.remove('velora-review-link-header'));
      const destination = mobile && header ? header : wrapper;
      if (mobile && header) header.classList.add('velora-review-link-header');
      const score = summary.average === null ? '' : summary.average.toLocaleString('hu-HU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      const label = `${score ? score + ' · ' : ''}${summary.count} értékelés`;
      const signature = `${summary.target.id}|${label}`;
      if (!row) {
        row = document.createElement('div');
        row.className = 'velora-review-link';
      }
      if (row.parentElement !== destination) destination.append(row);
      if (row.dataset.summary === signature) return;
      row.dataset.summary = signature;
      const link = document.createElement('a');
      link.className = 'velora-review-link__anchor';
      link.href = `#${summary.target.id}`;
      link.setAttribute('aria-label', `${label}. Ugrás a vásárlói értékelésekhez.`);
      if (summary.average !== null) {
        const stars = document.createElement('span');
        stars.className = 'velora-review-link__stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        stars.style.setProperty('--velora-rating-fill', `${summary.average / 5 * 100}%`);
        link.append(stars);
      }
      const text = document.createElement('span');
      text.className = 'velora-review-link__text';
      text.textContent = label;
      link.append(text);
      link.addEventListener('click', event => {
        event.preventDefault();
        const target = document.getElementById(summary.target.id);
        if (!target) return;
        const header = document.querySelector('.shopify-section-header-sticky');
        const offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        // Some templates place the review heading immediately before this section.
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset - 48), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        history.replaceState(null, '', link.getAttribute('href'));
      });
      row.replaceChildren(link);
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }
  function start() {
    refresh();
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !mutation.target.closest?.('.velora-review-link'))) schedule();
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    window.matchMedia('(max-width: 749px)').addEventListener('change', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
